import { useEffect, useMemo, useState } from "react";
import { reduceObj } from "../common/services/Utilities";
import { KeyValue } from "../interfaces";

interface Props {
  data: KeyValue;
  key: string;
  currentValues: string[];
  openClose: boolean;
  parent: string;
  setValues: (values: string[]) => void;
  setParent: (parent: string) => void;
  buttonDisplays: KeyValue;
  setButtonDisplays: (display: KeyValue) => void;
}
export default function useOpenCloseAll({
  data,
  key,
  currentValues,
  openClose,
  parent,
  setValues,
  setParent,
  buttonDisplays,
  setButtonDisplays,
}: Props) {
  const [previousKeys, setPreviousKeys] = useState<string[] | number[]>([]);
  const allByKey = useMemo(
    () =>
      data?.length > 0
        ? data
            .map((data: KeyValue) => data[key])
            .filter((value: string) => value)
        : [],
    [data, key],
  );

  useEffect(() => {
    if (JSON.stringify(previousKeys) !== JSON.stringify(allByKey)) {
      setPreviousKeys(allByKey);
      setButtonDisplays({});
    }
  }, [allByKey, previousKeys, setButtonDisplays]);

  useEffect(() => {
    if (allByKey.length > 0 && !buttonDisplays[parent]) {
      const openState = reduceObj(
        allByKey.map((key: string) => {
          return { key: key, value: false };
        }),
      );

      setButtonDisplays({ ...buttonDisplays, [parent]: openState });
    }
  }, [
    data,
    allByKey,
    buttonDisplays,
    currentValues,
    parent,
    setButtonDisplays,
  ]);

  useEffect(() => {
    if (openClose) {
      if (allByKey.length !== 0 && allByKey.length !== currentValues.length) {
        setValues(allByKey);
        const allTrue = reduceObj(
          Object.keys(buttonDisplays[parent]).map((val) => {
            return { key: val, value: true };
          }),
        );

        setButtonDisplays({ ...buttonDisplays, [parent]: allTrue });
      } else if (
        allByKey.length !== 0 &&
        allByKey.length === currentValues.length
      ) {
        const allFalse = reduceObj(
          Object.keys(buttonDisplays[parent]).map((val) => {
            return { key: val, value: false };
          }),
        );
        setButtonDisplays({ ...buttonDisplays, [parent]: allFalse });
        setValues([]);
      }
      setParent("");
    }
  }, [
    allByKey,
    buttonDisplays,
    currentValues.length,
    openClose,
    parent,
    setButtonDisplays,
    setParent,
    setValues,
  ]);
}
